import AutoSubmit from '@stimulus-components/auto-submit';
import $ from 'jquery';

export default class extends AutoSubmit {
  static values = {
    delay: {
      type: Number,
      default: 0 // You can change the default delay here.
    },
    reloadUrl: String
  };

  static targets = ['focusInput'];

  connect() {
    super.connect();
  }

  disconnect() {
    this.cancelPendingFocus();
    super.disconnect();
  }

  focusInputTargetConnected(input) {
    this.cancelPendingFocus();
    this.focusAbortController = new AbortController();
    // Initial autofocus must not override keyboard or pointer interaction.
    for (const event of ['keydown', 'pointerdown']) {
      input.ownerDocument.addEventListener(event, () => this.cancelPendingFocus(), {
        capture: true,
        signal: this.focusAbortController.signal
      });
    }
    this.focusTimeout = setTimeout(() => {
      this.cancelPendingFocus();
      if (!input.isConnected) return;

      // Check if this is inside a Select2 wrapper
      const $select = $(input).closest('[data-controller*="select2"]').find('select');
      if ($select.length && $select.data('select2')) {
        $select.select2('open');
      } else {
        input.select();
      }
    }, 200);
  }

  focusInputTargetDisconnected() {
    this.cancelPendingFocus();
  }

  cancelPendingFocus() {
    clearTimeout(this.focusTimeout);
    this.focusAbortController?.abort();
  }

  submitToTop() {
    // Change the target of the form to _top and then submit it
    this.element.setAttribute('target', '_top');
    this.element.setAttribute('data-turbo', 'false');
    this.element.requestSubmit();
  }

  submitReloadForm() {
    if (this.hasReloadUrlValue) {
      const frame = this.element.closest('turbo-frame');
      if (!frame) {
        console.warn('Could not reload form because it is not inside a Turbo Frame.');
        return;
      }

      const url = new URL(this.reloadUrlValue, window.location.origin);
      url.search = new URLSearchParams(new FormData(this.element)).toString();
      frame.src = url.toString();
    } else {
      console.warn(
        'No reloadUrl value provided for FormController. Please set data-form-reload-url-value to the URL you want to reload the form with.'
      );
    }
  }
}
